import { coachApi } from '@shared/api/client';
import type { PublishRequestRecord } from './types';
import { adaptPublishRequestRecord, adaptPublishRequestRecordList } from './adapters';

export const governanceApi = {
  listPublishRequests: async (siteId: string): Promise<PublishRequestRecord[]> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/publish-requests`);
    return adaptPublishRequestRecordList(raw);
  },
  createPublishRequest: async (
    siteId: string,
    data: { page_id: string; notes?: string }
  ): Promise<PublishRequestRecord> => {
    const raw = await coachApi.post<unknown>(`/webbuilder/sites/${siteId}/publish-requests`, data);
    return adaptPublishRequestRecord(raw);
  },
  approvePublishRequest: (siteId: string, reqId: string): Promise<{ approved: boolean }> =>
    coachApi.post<{ approved: boolean }>(`/webbuilder/sites/${siteId}/publish-requests/${reqId}/approve`, {}),
  rejectPublishRequest: (siteId: string, reqId: string, notes?: string): Promise<{ rejected: boolean }> =>
    coachApi.post<{ rejected: boolean }>(`/webbuilder/sites/${siteId}/publish-requests/${reqId}/reject`, { notes }),
  exportSiteBundle: (siteId: string): Promise<Record<string, unknown>> =>
    coachApi.get<Record<string, unknown>>(`/webbuilder/sites/${siteId}/export`),
  importSiteBundle: (siteId: string, bundle: unknown): Promise<{ imported: boolean; stats: unknown }> =>
    coachApi.post<{ imported: boolean; stats: unknown }>(`/webbuilder/sites/${siteId}/import`, bundle),
};

export const webbuilderApi = governanceApi;
export type * from './types';
